import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from '@/hooks/use-toast';
import { useTranslation } from '../useTranslation';
import { deleteDiscount, discountsQueryKeys } from '@api/discounts';

interface UseDeleteDiscountOptions {
  onSuccess?: () => void;
}

// Deletes a discount, then invalidates the discounts list so the row drops out
// on refetch. Mirrors useDeleteLocation — invalidate-on-success (not optimistic).
export function useDeleteDiscount(options?: UseDeleteDiscountOptions) {
  const queryClient = useQueryClient();
  const { onSuccess } = options || {};
  const { t } = useTranslation();

  return useMutation({
    mutationFn: deleteDiscount,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: discountsQueryKeys.lists() });
      toast({ description: t('destroy.success') });
      onSuccess?.();
    },
    onError: () => {
      // Deletes take no user input, so any failure is a generic infra/network
      // error — show the localized domain message, not a raw status string.
      toast({ description: t('destroy.error'), variant: 'destructive' });
    },
  });
}
